import React from 'react';
//import autoBind from 'react-autobind';

//import * as Components from '../Components.js';
//import * as Generation from '../Generation.js';
//import * as Helpers from '../Helpers.js';
import * as HomePage from './HomePage.js';

//import the Darwin API classes
//import API from '../API.js';

export class Pricing extends React.Component {

  constructor(props) {
    super(props)

    let data = {}

    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      shakeButton: false,

      view: "Home",
      subview: "Home",
    }
  }

  componentDidMount() {
    this.calculateView()
  }

  componentDidUpdate(prevProps) {
    if (this.props.render !== prevProps.render) {
      //reload the home view.
      this.calculateView()
    }
  }

  calculateView() {
  }

  render() {

    return (
      <div className="HomePage">
        {/* Page Header */}
        <HomePage.PageHeader />
        
        <HomePage.HomeHeader selected="pricing" openCloseMenu={this.props.openCloseMenu} userInfo={this.props.userInfo} />
        TODO - Pricing
      </div>
    )
  }
}
